import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';

const PbxProfileSkeleton = () => (
    <div className="animate-fade mx-auto flex w-full max-w-screen-sm items-start p-3 pt-6 text-gray-200 @sm:p-0">
        <div className="flex flex-1 flex-col gap-y-2 pb-2">
            <Skeleton.Text className="my-2 h-6 w-full" />
            <Skeleton.Text className="my-2 h-6 w-full" />
        </div>
    </div>
);

export default PbxProfileSkeleton;
